import './override.js'

export default globalThis
